import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react'
import Header from './../users/Header'
import NavHeader from './../users/NavHeader'
import { RxRocket } from 'react-icons/rx';
import { MdAddTask, MdContentCopy } from 'react-icons/md';
import NavMenu from './NavMenu';
import { UserAuth } from '../../context/AuthContext'
import ReactPaginate from 'react-paginate';
import SearchField from "react-search-field";
import GetData from './GetData';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import ReactDOM from 'react-dom';
import Footer from './../users/Footer'
import moment from 'moment';

const Menu = () => {
    const { user, garapAirdrop, detailPasukan, lihatAirdrop } = UserAuth();
    const uname = user.displayName;
    const [selectedProject, setSelectedProject] = useState(null);
    const { pasukanKu, htmlElement } = GetData({ project: selectedProject });

    const [error, setError] = useState('');
    const [loading, setLoading] = useState();
    const [showNotification, setShowNotification] = useState(false);
    const [timeoutId, setTimeoutId] = useState(null);

    const [nohpTelegram, setNohpTelegram] = useState('');
    const [usernameTelegram, setUsernameTelegram] = useState('');
    const [twitter, setTwitter] = useState('');
    const [email, setEmail] = useState('');
    const [facebook, setFacebook] = useState('');
    const [youtube, setYoutube] = useState('');
    const [medium, setMedium] = useState('');
    const [reddit, setReddit] = useState('');
    const [discord, setDiscordd] = useState('');


    useEffect(() => {
        return () => {
            clearTimeout(timeoutId);
        };
    }, [timeoutId]);

    /* Pasukan */
    const DataPasukan = [
        { id: 1, name: 'nohpTelegram', title: 'No HP', value: nohpTelegram },
        { id: 2, name: 'usernameTelegram', title: 'Telegram', value: usernameTelegram },
        { id: 3, name: 'twitter', title: 'Twitter', value: twitter },
        { id: 4, name: 'email', title: 'Email', value: email },
        { id: 5, name: 'discord', title: 'Discord', value: discord },
        { id: 6, name: 'facebook', title: 'Facebook', value: facebook },
        { id: 7, name: 'youtube', title: 'Youtube', value: youtube },
        { id: 8, name: 'medium', title: 'Medium', value: medium },
        { id: 9, name: 'reddit', title: 'Reddit', value: reddit }
    ];


    async function copyToClipboard(text) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch (err) {
            console.error('Failed to copy text: ', err);
            return false;
        }
    }

    const notifCopy = (message, name) => {
        if (message === "") {
            notification('Anda belum mengatur ' + name)
        } else {
            notification(message + " disalin ke clipboard")
        }

    }


    const notification = (message) => {
        const existingNotification = document.getElementById('copy-notif');
        if (existingNotification) {
            existingNotification.querySelector('#iziuse-notif-text').textContent = message;
        } else {
            const div = document.createElement('div');
            div.id = 'copy-notif';
            div.style.display = "flex"; // set display to flex
            div.style.justifyContent = "center"; // center content horizontally
            div.style.alignItems = "center"; // center content vertically
            document.body.insertBefore(div, document.body.firstChild);
            const Notif = () => {
                return (
                    <div className="px-4 fixed bottom-0 w-full max-w-[600px] transform mb-8 animate-fade-in animate-slide-up" style={{ zIndex: 9999 }}>
                        <div className="bg-stone-900 text-white w-full rounded p-4 text-sm font-semibold flex justify-between">
                            <div id="iziuse-notif-text">{message}</div>
                            <span className="text-primary cursor-pointer" id="iziuse-notif-ok">Ok</span>
                        </div>
                    </div>
                )
            }
            ReactDOM.render(<Notif />, document.getElementById('copy-notif'));
            div.querySelector('#iziuse-notif-ok').addEventListener('click', function () {
                div.remove();
            });
        }
    }



    window.addEventListener('keydown', async (event) => {
        if (selectedProject && pasukanKu) {

            const dataPasukan = DataPasukan;

            for (let i = 0; i < dataPasukan.length; i++) {
                if (event.altKey && event.key === `${i + 1}`) {
                    if (dataPasukan[i].value === "") {
                        notification(`Anda belum mengatur ${dataPasukan[i].name}`);
                    } else {
                        const copySuccess = await copyToClipboard(dataPasukan[i].value);
                        if (copySuccess) {
                            notification(`${dataPasukan[i].value} disalin ke clipboard`);
                        } else {
                            notification(`Gagal menyalin ${dataPasukan[i].value} ke clipboard`);
                        }

                    }
                }
            }
        }

    });

    const [limit, setLimit] = useState(50);
    const [limitName, setLimitName] = useState(50);
    const [limitChain, setLimitChain] = useState(50);

    useEffect(() => {
        const handleResize = () => {
            const screenWidth = window.innerWidth;
            if (screenWidth < 768) {
                setLimit(17);
                setLimitName(17);
                setLimitChain(5);
            } else {
                setLimit(50);
                setLimitName(17);
                setLimitChain(5);
            }
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const GarapPasukan = DataPasukan.map((hasil, i) =>
        <tr key={hasil.id} className='hover:bg-gray-200'>
            <td className='py-2 px-3 font-semibold w-2/12 text-sm'>{hasil.title}</td>
            <td className="py-2 px-3 w-2/4 text-sm">
                {hasil.value.length > limit ? (
                    <span title={hasil.value}>{hasil.value.slice(0, limit)}...</span>
                ) : (
                    <span>{hasil.value}</span>
                )}
            </td>
            <td className='py-2 px-3 w-2/12 text-right'>
                <CopyToClipboard text={hasil.value}>
                    <button onClick={() => notifCopy(hasil.value, hasil.title)} className="py-1 px-2 text-zinc-200 bg-sky-500 text-sm font-medium rounded-md flex items-center">
                        <MdContentCopy size='18px' className='text-cyan-50/70 mr-1' /> Copy
                    </button>

                </CopyToClipboard>
            </td>
        </tr>
    );


    const tableRef = useRef(null); // create a ref for the table element

    useEffect(() => {
        // scroll to the table element when the component is mounted or updated
        if (tableRef.current) {
            tableRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
            tableRef.current.focus();
        }
    }, [pasukanKu]);

    const tampilinCuy = useCallback(() => {

        const doneGarap = async (e) => {
            setLoading(true);
            try {
                const send = await garapAirdrop(uname, selectedProject, pasukanKu)
                if (send === true) {
                    notification('Perubahan berhasil disimpan');
                }
            } catch (e) {
                notification(e.message)
            } finally {
                setLoading(false);
            }
        }
        return (
            <div className="overflow-x-auto">
                <table ref={tableRef} tabIndex={-1} className='w-full items-center text-left table-auto'>
                    <tbody className='font-normal text-sm text-zinc-600 border-b'>
                        {GarapPasukan}
                    </tbody>
                </table>
                <div className='py-2 leading-3 px-3'>
                    <h2 className='text-sm'>Catatan: Setelah selesai garap airdrop dengan data di atas, kamu bisa menekan tombol di bawah ini</h2>
                </div>
                <div className='px-3 pb-6 flex justify-center'>
                    <button onClick={doneGarap} className='px-4 py-2 text-white font-semibold bg-sky-500/90 rounded-md w-1/2 text-center'>Done</button>
                </div>
            </div>
        )
    }, [GarapPasukan, garapAirdrop, pasukanKu, selectedProject, uname])

    useEffect(() => {
        if (selectedProject && pasukanKu) {
            const ajg = async () => {
                const result = await detailPasukan(uname, pasukanKu);
                setNohpTelegram(result[0].nohpTelegram);
                setUsernameTelegram(result[0].usernameTelegram);
                setTwitter(result[0].twitter);
                setEmail(result[0].email);
                setFacebook(result[0].facebook);
                setYoutube(result[0].youtube);
                setMedium(result[0].medium);
                setReddit(result[0].reddit);
                setDiscordd(result[0].discord);
            }
            ajg();
        }
    }, [selectedProject, pasukanKu, uname, detailPasukan, tampilinCuy])




    useEffect(() => {
        return () => {
            clearTimeout(timeoutId);
        };
    }, [timeoutId]);

    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");

    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const result = await lihatAirdrop(uname);
                setData(result);
            } catch (error) {
                setShowNotification(true);
                setError(error.message);
            }
            setLoading(false);
        };

        fetchData();
        setTimeoutId(setTimeout(() => setShowNotification(false), 7000));
        setCurrentPage(0); // reset currentPage when searchQuery changes
    }, [lihatAirdrop, uname, searchQuery]);

    const filteredData = useMemo(() => {
        return data.filter((item) => {
            return (
                item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                item.chain.toLowerCase().includes(searchQuery.toLowerCase())
            );
        })
            .sort((a, b) => b.added - a.added);
    }, [data, searchQuery]);

    const startIndex = filteredData.length > 0 ? currentPage * itemsPerPage + 1 : 0;
    const endIndex = Math.min(startIndex + itemsPerPage - 1, filteredData.length);
    const itemsToShow = filteredData.slice(startIndex - 1, endIndex);

    const sectionRef = useRef(null);

    const handleClick = (itemName) => {
        setSelectedProject(itemName);

        if (sectionRef.current) {
            sectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
            sectionRef.current.focus();
        }
    }


    const TimestampToDate = (props) => {
        const timestamp = props.timestamp;
        const date = moment(timestamp).format('DD/MM/YY');
        return date;
    }

    return (
        <div className="antialiased bg-primary md:block md:bg-indigo-50" style={{ backgroundImage: `url('/images/bg-body.png')` }} relative>
            <NavHeader />
            <div className="max-w-[600px] mx-auto min-h-screen bg-slate-100 shadow-2xl relative">
                <Header />
                {loading && (
                    <div className="absolute top-0 left-0 right-0 bottom-0 bg-black opacity-60 flex items-center justify-center z-50">
                        <img src='/logo192.png' alt="Loading..." className="w-10 h-10" />
                    </div>
                )}
                {showNotification && (
                    <div id="notif">
                        <div className="px-4 fixed bottom-0 w-full max-w-[600px] transform mb-8 animate-fade-in animate-slide-up z-50">
                            <div className="bg-stone-900 text-white w-full rounded p-4 text-sm font-semibold flex justify-between">
                                {error}
                                <span className="text-primary cursor-pointer" onClick={() => setShowNotification(false)}>Ok</span>
                            </div>
                        </div>
                    </div>
                )}
                <div className='pt-3 pb-[96px]'>
                    <div className='bg-white'>
                        <div className='px-4 pt-4 pb-2 md:p-4 flex justify-between items-center'>
                            <div className='flex items-center'>
                                <span className="mr-2">
                                    <RxRocket className='h-[14px] w-[14px] md:h-[16px] md:w-[16px]' />
                                </span>
                                <h1 className='font-semibold text-base md:text-lg'>Garap Airdrop</h1>
                            </div>
                            <div className='text-primary md:font-semibold font-bold text-sm md:text-base'>
                                Pelajari
                            </div>
                        </div>
                        <NavMenu />
                        <div className="bottom-0 bg-slate-100 h-[4px] z-10 -mt-1"></div>
                        <div className=''>
                            <div className='flex justify-between items-center'>
                                <div className='flex items-center p-4'>
                                    <span className='mr-2'>
                                        <MdAddTask size='20' />
                                    </span>
                                    <h1 className='font-semibold text-base'>Garap Airdrop</h1>
                                </div>
                            </div>
                            <div className='px-4 py-2'>
                                {selectedProject && pasukanKu && tampilinCuy(pasukanKu)}
                            </div>
                            <div className='px-4 py-2'>
                                <div className='relative overflow-hidden border border-slate-100 px-4 py-2 bg-gradient-to-r from-sky-500 to-blue-600 rounded-lg'>
                                    <div className='absolute rounded-full w-3/4 h-40 bg-sky-500/60 -left-80 bottom-0'></div>
                                    <div className='absolute rounded-full w-3/4 h-40 bg-blue-600/50 -right-80'></div>
                                    <div className="text-center">
                                        {itemsToShow.map((item, index) => (
                                            <>
                                                <div className='py-1' key={index}>
                                                    <h1 className='text-xl md:text-2xl font-semibold text-white'>Project Name</h1>
                                                </div>
                                                <div className='py-1 flex justify-center'>
                                                    <h1 className='text-lg md:text-xl font-bold text-white'>
                                                        {item.name.length > limitName ? (
                                                            <span title={item.name}>{item.name.slice(0, limitName)}...</span>
                                                        ) : (
                                                            <span>{item.name}</span>
                                                        )}
                                                    </h1>
                                                    {item.chain !== '' ? <h2 className='text-base md:text-xl font-semibold text-white'>
                                                        (
                                                        {item.chain.length > limitChain ? (
                                                            <span title={item.chain}>{item.chain.slice(0, limitChain)}...</span>
                                                        ) : (
                                                            <span>{item.chain}</span>
                                                        )})
                                                    </h2> : ''}

                                                </div>
                                                <div className='py-1'>
                                                    <h1 className='text-white text-sm md:text-base font-normal'>ditambahkan {TimestampToDate(item.added)}</h1>
                                                </div>
                                                <div className=''>
                                                    <button onClick={() => handleClick(item.name)} className='text-sm px-2 py-1 text-white font-semibold bg-cyan-400 border-2 border-cyan-400 shadow-xl shadow-cyan-400/50 rounded-md'>
                                                        Get Data
                                                    </button>
                                                </div>
                                            </>
                                        ))}
                                    </div>
                                    <div className='py-4 flex justify-center items-center'>
                                        <SearchField
                                            placeholder="Search..."
                                            onChange={(value) => {
                                                setSearchQuery(value);
                                                setCurrentPage(0);
                                            }}
                                        />
                                    </div>
                                    <div className='text-center'>
                                        <div className='text-sm text-white'>
                                            Showing {startIndex > 0 ? startIndex : 0} to {endIndex} of {filteredData.length} entries
                                        </div>
                                    </div>
                                    <div className='pb-2'>
                                        <ReactPaginate
                                            previousLabel={
                                                <span className="text-white px-4 py-2">
                                                    &lt;
                                                </span>
                                            }
                                            nextLabel={
                                                <span className="text-white px-4 py-2">
                                                    &gt;
                                                </span>
                                            }
                                            breakLabel='...'
                                            pageCount={Math.ceil(filteredData.length / itemsPerPage)}
                                            marginPagesDisplayed={1}
                                            pageRangeDisplayed={1}
                                            onPageChange={handlePageChange}
                                            containerClassName={'flex justify-center mt-4 text-sm'}
                                            activeClassName={'bg-cyan-400 border-2 border-cyan-300 text-white px-4 py-2 !important'}
                                            pageClassName={'border border-gray-100 px-4 py-2 text-white '}
                                            breakClassName={'border border-gray-100 px-4 py-2 text-white '}
                                            previousClassName={'border border-gray-100 px-4 py-2 text-white '}
                                            nextClassName={'border border-gray-100 px-4 py-2 text-white '}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div ref={sectionRef} className='p-4' tabIndex={-1}>
                                {selectedProject && htmlElement}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div >
    )
}

export default Menu
